export default __webpack_public_path__ + "static/media/516ddd04e23dd143d6d73986d5314b7e.svg";